import platform from 'platform'
import ERRORS from './environment-errors.js'

/* eslint-disable no-unused-vars */

const environmentWebImplementation = {
  isMobileApplication: function(resolve, reject) {
    resolve(false)
  },
  getBridgeAPIs: function(resolve, reject) {
    resolve([])
  },
  getApplicationInstallID: function(resolve, reject) {
    resolve(null)
  },
  getUserAgent: function(resolve, reject) {
    resolve(navigator.userAgent)
  },
  getPlatformInformation: function(resolve, reject) {
    let result = {
      applicationType: 'Browser',
      applicationName: platform.name,
      version: platform.version,
      manufacturer: platform.manufacturer,
      product: platform.product,
      productCode: null,
      layoutEngine: platform.layout,
      os: platform.os,
      description: platform.description
    }
    result.os.string = platform.os.toString()
    delete result.os.toString
    resolve(result)
  },
  getWebDebuggingEnabled: function(resolve, reject) {
    resolve(true)
  },
  isActiveNetworkWifi: function(resolve, reject) {
    reject({
      name: ERRORS.METHOD_NOT_SUPPORTED,
      message: "Can't determin network type on this platform."
    })
  },
  getApplicationBaseURL: function(resolve, reject) {
    resolve(location.protocol + '//' + location.host)
  }
}

export default environmentWebImplementation
